import css from './frame.module.scss';

import { memo } from 'react';

import Button from 'core/ui/Button';

import { Menu } from '../Menu';
import ICONS from '../icons';

type TProps = {
  theme?: 'light' | 'default';
  children: React.ReactNode;
  closeLink?: string;
  menuItems?: React.ReactNode;
};

const FrameHeader = ({
  children,
  closeLink = '/',
  menuItems,
  theme = 'default',
}: TProps) => {
  return (
    <div className={css.header} data-theme={theme}>
      <div className={css.headerText}>{children}</div>
      {menuItems && (
        <Menu
          anchor={({ setRef, toggle }) => (
            <Button
              onRef={setRef}
              onClick={toggle}
              theme="flat"
              title="Show menu"
              children={ICONS.Menu}
            />
          )}
          children={menuItems}
        />
      )}
      <Button
        className={css.headerCloseButton}
        link={closeLink}
        children="close"
      />
    </div>
  );
};

export default memo(FrameHeader);
